import ReactGA from "react-ga4";
import store from "../redux/store";

export function sendPageViewEvent(data) {
  ReactGA.send('pageview', { ...data });
}

export function sendGTMEvent({ eventName, data = {}, category = "UI" }) {
  const dimensionsData = prepareDimensions();
  ReactGA.event({
    action: eventName,
    category,
    ...dimensionsData,
    ...data,
  });
}

export function getGtagId() {
  return process.env.REACT_APP_GTAG_ID;
}

export function prepareDimensions() {
  const { userData: { userId }, businessData: {
    brandName, branchName,
    branchId, businessName
  }
  } = store.getState().businessReducer;
  return {
    dimension1: userId,
    dimension2: branchId,
    dimension3: branchName,
    dimension4: brandName,
    dimension5: businessName
  };
}

export function initialGoogleAnalytics() {
  ReactGA.initialize(getGtagId());
}